export interface TeamPlanOrderModeParams {
  isExpired: boolean
  isSamePlan: boolean
}

export function shouldModifyTeamPlan({ isExpired, isSamePlan }: TeamPlanOrderModeParams): boolean {
  return !isExpired && !isSamePlan
}

export interface TeamPlanCheckoutParams extends TeamPlanOrderModeParams {
  pricePerMonth: number
  upgradePrice?: number
}

export interface TeamPlanCheckout {
  modify: boolean
  priceCent: number
}

export function getTeamPlanCheckout({
  isExpired,
  isSamePlan,
  pricePerMonth,
  upgradePrice,
}: TeamPlanCheckoutParams): TeamPlanCheckout {
  const modify = shouldModifyTeamPlan({ isExpired, isSamePlan })

  return {
    modify,
    priceCent: modify ? (upgradePrice ?? 0) : pricePerMonth,
  }
}

export interface TeamPlanAvailabilityParams {
  isExpired: boolean
  planId: string
  planPrice: number
  currentPlanId?: string
  currentPlanPrice?: number
}

export function isManageTeamPlanSelectable({
  isExpired,
  planId,
  planPrice,
  currentPlanId,
  currentPlanPrice,
}: TeamPlanAvailabilityParams): boolean {
  if (currentPlanId && planId === currentPlanId) return isExpired
  if (currentPlanPrice !== undefined && planPrice <= currentPlanPrice) return false

  return true
}
